import styled from "styled-components";

export const Container = styled.div`
	display: block;

	position: relative;

	width: 100%;
	height: 100%;

	background-color: #ececec;

	align-items: center;
	justify-content: center;

	iframe {
		height: 100%;
		width: 100%;
	}

	.select-docs {
		width: 3.5rem;
		height: 3.5rem;

		position: absolute;

		bottom: 0.5rem;
		left: 0;

		padding: 0.25rem;
	}

	.docs-button {
		width: 100%;
		height: 100%;

		border: none;
		border-radius: 50%;

		background-color: white;

		cursor: pointer;

		transition: 0.2s;

		:hover {
			background-color: #3751ff;
		}
	}

	.menu {
		transition: width 0.3s;
		&.hidden {
			width: 0;
		}

		&.show {
			position: absolute;

			display: flex;

			width: 35vw;
			height: 100vh;

			overflow: hidden;

			top: 0;
			left: 4px;

			.out-docs {
				display: flex;
				flex-direction: column;

				margin-top: 5rem;

				align-items: center;

				color: #d6d7e0;

				path {
					stroke: #d6d7e0;
				}

				p {
					font-size: 1.5rem;
					font-weight: 600;

					margin-top: 1rem;
				}
			}

			.file-doc {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				padding: 1rem;
				margin: 0.5rem;

				cursor: pointer;

				transition: background-color ease 0.3s;

				h4 {
					color: #3751ff;
					font-size: 1.5rem;
					font-weight: 600;
				}
			}

			.file-doc:hover {
				background-color: #dddddd;
			}
		}
	}

	.doc-bg {
		width: 100%;
		height: 100%;

		background-color: white;

		border-radius: 0.3rem;
	}

	.doc-header-wrapper {
		display: flex;

		width: 100%;
		height: 5rem;

		justify-content: space-around;
		align-items: center;

		padding: 0 1rem 0 1rem;
	}

	.doc-button {
		width: 2rem;
		height: 2rem;

		#exit-docs {
			display: flex;

			width: 100%;
			height: 2rem;

			align-items: center;
			justify-content: center;

			border: none;
			border-radius: 50%;

			background: none;

			cursor: pointer;

			transition: 0.2s;

			:hover {
				background-color: red;

				svg {
					color: white;
				}
			}
		}

		svg {
			width: 1.5rem;
			height: 1.5rem;

			color: red;
		}
	}

	.doc-header {
		font-size: 1.5rem;
		font-weight: 700;

		text-align: center;

		color: #3751ff;
	}

	.search-container {
		display: flex;
		flex-direction: column;

		justify-content: center;

		margin-left: 2rem;

		height: 3rem;

		#search {
			border: 2px solid #3751ff;

			background-color: white;
		}

		.search-wrapper {
			display: grid;
			grid-template-columns: max-content max-content;

			align-items: center;
		}

		.button-menu {
			position: relative;

			display: flex;

			width: 10rem;
			height: 2rem;
		}

		.button {
			position: absolute;

			display: flex;

			width: 2.5rem;
			height: 2.5rem;

			border: none;
			border-radius: 2.5rem;

			overflow: hidden;

			align-items: center;

			cursor: pointer;

			transition: 0.35s ease-in-out;
		}

		.button.show {
			height: 2.5rem;

			width: 28rem;

			border-radius: 0.5rem;
		}

		.icon-wrapper {
			display: flex;

			width: 2.3rem;
			height: 100%;

			align-items: center;
			justify-content: center;

			svg {
				width: 1.5rem;
				height: 1.5rem;

				color: #3751ff;
			}
		}

		.input-wrapper {
			width: 2rem;
			input {
				width: 30rem;

				background: none;

				font-size: 1.2rem;

				color: #3751ff;

				border: none;

				::placeholder {
					color: #3751ff;
				}
			}
		}
	}

	.docs-list-wrapper {
		display: grid;

		height: 100%;

		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		grid-template-rows: repeat(auto-fill, minmax(140px, 1fr));

		grid-gap: 0.5rem;

		padding: 1rem;

		overflow: auto;
	}

	.doc-item {
		iframe {
			width: 12rem;

			border: 0px none;
		}
	}
	menu {
		transition: width 0.3s;
	}

	.hidden {
		width: 0;
	}

	.show {
		position: absolute;

		display: flex;

		width: 35vw;
		height: 100vh;

		overflow: hidden;

		top: 0;
		left: 4px;

		.out-docs {
			display: flex;
			flex-direction: column;

			margin-top: 5rem;

			align-items: center;

			color: #d6d7e0;

			path {
				stroke: #d6d7e0;
			}

			p {
				font-size: 1.5rem;
				font-weight: 600;

				margin-top: 1rem;
			}
		}

		.file-doc {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			padding: 1rem;
			margin: 0.5rem;

			cursor: pointer;

			transition: background-color ease 0.3s;

			h4 {
				color: #3751ff;
				font-size: 1.5rem;
				font-weight: 600;
			}
		}

		.file-doc:hover {
			background-color: #dddddd;
		}
	}

	.hidden {
		display: none;
	}

	.select-docs {
		width: 3.5rem;
		height: 3.5rem;

		position: absolute;

		bottom: 0.5rem;
		left: 0;

		padding: 0.25rem;
	}

	.docs-button {
		width: 100%;
		height: 100%;

		border: none;
		border-radius: 50%;

		background-color: white;

		cursor: pointer;

		transition: 0.2s;

		:hover {
			background-color: #3751ff;
		}
	}

	#button-icon {
		width: 70%;
		height: 70%;
	}

	.header {
		display: flex;

		width: 100%;

		justify-content: space-between;
		align-items: center;

		text-transform: uppercase;

		color: white;

		button {
			border: none;
			background: none;

			cursor: pointer;

			transition: all 0.2s;

			border-radius: 50%;

			padding: 0.5rem 0.6rem;

			svg {
				polyline {
					stroke: #3751ff;
					stroke-width: 3;
				}
			}
		}

		button:hover {
			background-color: rgba(55, 81, 255, 0.2);
		}
	}

	.doc-bg {
		width: 100%;
		height: 100%;

		background-color: white;

		border-radius: 0.3rem;
	}

	.doc-header-wrapper {
		display: flex;

		width: 100%;
		height: 5rem;

		justify-content: space-around;
		align-items: center;

		padding: 0 1rem 0 1rem;
	}

	.doc-button {
		width: 2rem;
		height: 2rem;

		#exit-docs {
			display: flex;

			width: 100%;
			height: 2rem;

			align-items: center;
			justify-content: center;

			border: none;
			border-radius: 50%;

			background: none;

			cursor: pointer;

			transition: 0.2s;

			:hover {
				background-color: red;

				svg {
					color: white;
				}
			}
		}

		svg {
			width: 1.5rem;
			height: 1.5rem;

			color: red;
		}
	}

	.doc-header {
		font-size: 1.5rem;
		font-weight: 700;

		text-align: center;

		color: #3751ff;
	}

	.search-container {
		display: flex;
		flex-direction: column;

		justify-content: center;

		margin-left: 2rem;

		height: 3rem;

		#search {
			border: 2px solid #3751ff;

			background-color: white;
		}

		.search-wrapper {
			display: grid;
			grid-template-columns: max-content max-content;

			align-items: center;
		}

		.button-menu {
			position: relative;

			display: flex;

			width: 10rem;
			height: 2rem;
		}

		.button {
			position: absolute;

			display: flex;

			width: 2.5rem;
			height: 2.5rem;

			border: none;
			border-radius: 2.5rem;

			overflow: hidden;

			align-items: center;

			cursor: pointer;

			transition: 0.35s ease-in-out;
		}

		.button.show {
			height: 2.5rem;

			width: 28rem;

			border-radius: 0.5rem;
		}

		.icon-wrapper {
			display: flex;

			width: 2.3rem;
			height: 100%;

			align-items: center;
			justify-content: center;

			svg {
				width: 1.5rem;
				height: 1.5rem;

				color: #3751ff;
			}
		}

		.input-wrapper {
			width: 2rem;
			input {
				width: 30rem;

				background: none;

				font-size: 1.2rem;

				color: #3751ff;

				border: none;

				::placeholder {
					color: #3751ff;
				}
			}
		}
	}

	.docs-list-wrapper {
		display: grid;

		height: 100%;

		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		grid-template-rows: repeat(auto-fill, minmax(140px, 1fr));

		grid-gap: 0.5rem;

		padding: 1rem;

		overflow: auto;
	}

	.doc-item {
		iframe {
			width: 12rem;

			border: 0px none;
		}
	}
`;
